import CardActions from '@material-ui/core/CardActions';
import React from 'react';
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  List,
  ListButton,
  LongTextInput,
  Responsive,
  SaveButton,
  SimpleForm,
  SimpleList,
  TextField,
  Toolbar,
} from 'react-admin';

export const TncList = props => (
  <List {...props} bulkActionButtons={false}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => `${record.name}`}
          secondaryText={record => record.display_name}
        />
      }
      medium={
        <Datagrid>
          <EditButton />
          <TextField source="name" />
          <TextField source="display_name" />
          <BooleanField source="active" />
        </Datagrid>
      }
    />
  </List>
);

export const TncCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <LongTextInput source="name" />
      <BooleanInput source="active" />
      <LongTextInput source="display_name" />
      <LongTextInput source="logo_url" />
      <LongTextInput source="hex_color" />
    </SimpleForm>
  </Create>
);

const PostEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const TncEdit = props => (
  <Edit title={<TncTitle />} actions={<TncActions />} {...props}>
    <SimpleForm toolbar={<PostEditToolbar />}>
      <DisabledInput source="id" />
      <LongTextInput source="name" />
      <BooleanInput source="active" />
      <LongTextInput source="display_name" />
      <LongTextInput source="logo_url" />
      <LongTextInput source="hex_color" />
    </SimpleForm>
  </Edit>
);

const TncTitle = ({ record }) => {
  return <span>{record ? `"${record.name}"` : ''}</span>;
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const TncActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/tncs.js